import Brand from "../components/Brand";
import Controls from "../components/Controls";
import { useTourMode } from "../components/TourMode";
import { useTranslation } from "../components/Localization";

export default function TourSetupPage() {
  const { interactive, setInteractive } = useTourMode();
  const { t } = useTranslation();
  return (
    <main className="screen setup">
      <section className="top-title">
        <Brand compact />
        <h1>
          {t("setup.title")}
        </h1>
      </section>
      <div className="center-copy">
        {t("setup.question")}
      </div>
      <button
        className={`toggle ${interactive ? "yes" : ""}`}
        onClick={() => setInteractive(!interactive)}
        aria-pressed={interactive}
      >
        <span>{t("setup.yes")}</span>
        <i>
          <b />
        </i>
        <span>{t("setup.no")}</span>
      </button>
      <Controls backTo="/" nextTo={interactive ? "/hogyan-mukodik" : "/rezidencia"} />
    </main>
  );
}
